export default "__VITE_ASSET__3d20ddf3__"